export default "__VITE_ASSET__DHrOZoqz__"